import { MTMCustomFile, TransferType } from './mtm-custom-file';
import { Injectable } from '@angular/core';
import { listenerUploadStatusChanged } from './listeners';
import { TransferStatus } from './transfer-status';

export interface UploadQueueItem {
  file: MTMCustomFile;
  uploadFn: () => void;
}

@Injectable({
  providedIn: 'root',
})
export class TransferQueueService {
  private readonly uploadQueue: UploadQueueItem[] = [];
  private activeUploads: number = 0;
  private readonly maxConcurrentUploads: number = 3;

  constructor() {}

  enqueueUpload(item: UploadQueueItem) {
    this.uploadQueue.push(item);
    this.processQueue();
  }

  private processQueue() {
    if (this.activeUploads >= this.maxConcurrentUploads || this.uploadQueue.length == 0) {
      return;
    }

    while (this.activeUploads < this.maxConcurrentUploads && this.uploadQueue.length > 0) {
      const item = this.uploadQueue.shift();
      if (item) {
        this.startUpload(item);
      }
    }
  }

  private startUpload(item: UploadQueueItem) {
    this.activeUploads++;
    const subscription = item.file.progress$.subscribe((progress) => {
      switch (progress?.status) {
        case TransferStatus.SCANNING:
        case TransferStatus.ERROR:
        case TransferStatus.COMPLETED:
        case TransferStatus.QUARANTINED:
        case TransferStatus.CANCELED:
          this.activeUploads--;
          if (this.activeUploads < 0) {
            this.activeUploads = 0;
          }

          this.processQueue();
          subscription.unsubscribe();
          break;
      }
    });
    item.uploadFn();
  }
}
